import React from 'react';
import {
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
} from '@mui/material';
import {
  CloudUpload,
  CreateNewFolder,
  Refresh,
} from '@mui/icons-material';
import { useTheme, alpha } from '@mui/material/styles';

const FileOperationsSpeedDial = ({
  onUploadClick,
  onNewFolderClick,
  onRefreshClick,
  isAtRoot = true,
  disabled = false
}) => {
  const theme = useTheme();

  return (
    <SpeedDial
        ariaLabel="File operations"
        direction="up"
        sx={{
          position: 'fixed',
          bottom: { xs: 16, sm: 24 },
          right: { xs: 16, sm: 24 },
          zIndex: 1000,
          '& .MuiSpeedDial-fab': {
            backgroundColor: theme.palette.primary.main,
            boxShadow: 3,
            width: { xs: 56, sm: 64 },
            height: { xs: 56, sm: 64 },
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
              boxShadow: 4
            },
            '&.MuiSpeedDial-open': {
              backgroundColor: theme.palette.secondary.main,
              transform: 'rotate(45deg)'
            }
          },
          '& .MuiSpeedDial-actions': {
            zIndex: 999,
            '& .MuiSpeedDialAction-fab': {
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              color: theme.palette.primary.main,
              width: { xs: 48, sm: 56 },
              height: { xs: 48, sm: 56 },
              boxShadow: 2,
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
                boxShadow: 3
              }
            }
          }
        }}
        icon={<SpeedDialIcon />}
        FabProps={{
          sx: {
            '&:focus': {
              outline: `2px solid ${theme.palette.primary.main}`,
              outlineOffset: 2
            }
          }
        }}
        tooltipTitle="File operations"
      >
        <SpeedDialAction
          key="upload"
          icon={<CloudUpload />}
          tooltipTitle="Upload Files"
          onClick={() => {
            onUploadClick();
          }}
          FabProps={{
            sx: {
              '&:focus': {
                outline: `2px solid ${theme.palette.primary.main}`,
                outlineOffset: 2
              }
            }
          }}
        />
        <SpeedDialAction
          key="newfolder"
          icon={<CreateNewFolder />}
          tooltipTitle="New Folder"
          onClick={() => {
            onNewFolderClick();
          }}
          FabProps={{
            disabled: disabled,
            sx: {
              opacity: !disabled ? 1 : 0.5,
              '&:focus': {
                outline: `2px solid ${theme.palette.primary.main}`,
                outlineOffset: 2
              }
            }
          }}
        />
        <SpeedDialAction
          key="refresh"
          icon={<Refresh />}
          tooltipTitle="Refresh"
          onClick={() => {
            onRefreshClick();
          }}
          FabProps={{
            sx: {
              '&:focus': {
                outline: `2px solid ${theme.palette.primary.main}`,
                outlineOffset: 2
              }
            }
          }}
        />
      </SpeedDial>
  );
};

export default FileOperationsSpeedDial;